import React, { useState } from 'react';
import {operators, TableDetails, TableInput, useTableCreation} from '../../TableTemplate';
import {RuleGroup} from '../../../backend/model';
import { RuleGroupLink } from '../../TableItemLink';
import { Checkbox } from '@amzn/awsui-components-react';
import { RULE_GROUP_DELIMITER } from '../../../common/constants';

const TABLE_ID = 'ruleGroupsTable';

const COLUMN_DEFINITIONS = [
    {
        id: 'name',
        header: 'Name',
        cell: (ruleGroup: RuleGroup) => <RuleGroupLink ruleGroupName={ruleGroup.name} />,
        sortingField: "name",
    },
];

const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'Name',
        key: 'name',
        groupValuesLabel: 'Rule Group Name',
        operators: operators,
    },
];

const RuleGroupsTable: React.FC<TableInput> = ({tableItems, fileName}) => {
    const [subRuleGroupsChecked, setSubRuleGroupsChecked] = useState(false)

    const ruleGroupsFiltered = subRuleGroupsChecked ? tableItems : tableItems.filter(item => !item.name.includes(RULE_GROUP_DELIMITER))

    const renderSubRuleGroupsCheckbox = () => (
        <Checkbox onChange={({ detail }) => {
            setSubRuleGroupsChecked(detail.checked)
        }} checked={subRuleGroupsChecked}>Show Sub Rule Groups</Checkbox>
    )

    const tableDetails: TableDetails = {
        tableId: TABLE_ID,
        header: '',
        fileName: fileName,
        getRow: function (row: any): string[] {
            return [row.name];
        },
    };
    return useTableCreation(tableDetails, COLUMN_DEFINITIONS, ruleGroupsFiltered, FILTERING_PROPERTIES, 0, undefined, renderSubRuleGroupsCheckbox);
};

export default RuleGroupsTable;
